import { useState } from "react";

import Modal from "./Modal";

import useLocalization from "../../hooks/useLocalization";
import useBrowser from "../../hooks/useBrowser";

import SurveySectionEditor from "../editors/SurveySectionEditor";
import Dialog_YesNo from "../ui/Dialog_YesNo";

const SurveySectionModal = ({
  surveyId,
  surveyPageId,
  section,
  open,
  onClose,
  onSave,
  onDelete,
  canDelete = false,
}) => {
  const { getMessage } = useLocalization();
  const { windowHeight } = useBrowser();

  const [changesMade, setChangesMade] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const handleClose = () => {
    if (!changesMade) onClose();

    setOpenDialog(true);
  };

  const handleYes = () => {
    setOpenDialog(false);
    onClose();
  };

  const handleNo = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <Modal
        title={section?.name || "New Section"}
        open={open}
        onClose={handleClose}
        width="600px"
        height={`${windowHeight}px`}
      >
        <SurveySectionEditor
          onSave={onSave}
          onDelete={onDelete}
          surveyId={surveyId}
          surveyPageId={surveyPageId}
          section={section}
          changesMade={(newValue) => setChangesMade(newValue)}
          canDelete={canDelete}
        />
      </Modal>

      <Dialog_YesNo
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onYes={handleYes}
        onNo={handleNo}
        title={getMessage("cancelChanges")}
        message={getMessage("changesWillBeLost")}
      />
    </>
  );
};

export default SurveySectionModal;
